// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thats-attr[data-v-361b759a] {\n  padding: 0;\n  margin: 0;\n}\n.thats-attr li[data-v-361b759a] {\n  list-style: none;\n  display: flex;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
